export default "__VITE_ASSET__CzHKMR02__"